<template lang="pug">
    .container.content(v-if="contents && contents.length" ref="container")
        .schema.classic(v-if="schema === 'classic'")
            .column.is-offset-1.is-10
                Heading(v-if="heading" :heading="heading.title" :subHeading="heading.sub_title")
            .content-wrap(:class="{ 'column is-offset-1 is-10': imagePosition === 'left-float' }")
                .images(v-if="images && images.length" :class="imagePosition")
                    PostImage(
                        v-for="image in images" :key="image.id"
                        :content="image"
                        :count="images.length"
                        :max-width="containerWidth"
                        :shadow="shadow"
                        :imageAltText="imageAltText"
                    )
                div(v-if="content && content.text" v-html="content.text" :class="{ 'column is-offset-1 is-10': imagePosition === 'top-block' }")
                div.clear
        .schema.nextTo(v-else) 
            .wrap.flex(:class="{ 'column is-offset-1 is-10': imagePosition === 'left-float' }")
                .images(v-if="images && images.length" :class="imagePosition")
                    PostImage(
                        v-for="image in images" :key="image.id"
                        :content="image"
                        :count="images.length"
                        :max-width="containerWidth"
                        :shadow="shadow"
                        :imageAltText="imageAltText"
                    )
                .content
                    HeadingNextTo(v-if="heading" :heading="heading.title" :subHeading="heading.sub_title")
                    div(v-if="content && content.text" v-html="content.text" :class="{ 'column is-offset-1 is-10': imagePosition === 'top-block' }")
</template>

<script>

// import _ from 'lodash'
import debounce from 'lodash.debounce'

import Heading from './Heading'
import HeadingNextTo from './HeadingNextTo'
import PostImage from './PostImage'

export default {
    name: 'Post',
    data() {
        return {
            containerWidth: undefined,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Heading,
        HeadingNextTo,
        PostImage,
    },
    computed: {
        contents() {
            return this.section.contents || []
        },
        heading() {
            return this.contents.find(content => content.key === 'heading')
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        images() {
            return this.contents.filter(content => content.key === 'image')
        },
        imageAltText() {
            return this.heading?.title 
                || this.heading?.sub_title 
                || this.images?.[0]?.images?.[0]?.name;
        },
        imagePosition() {
            let position = 'left-float'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_position')
                if (setting && setting.value !== undefined) position = setting.value
            }

            return position
        },
        shadow() {
            let shadow = 'box-shadow-2'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_shadow')
                if (setting && setting.value !== undefined) shadow = setting.value
            }

            return shadow
        },
        schema() {
            let schema = 'classic'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'schema')
                if (setting && setting.value !== undefined) schema = setting.value
            }

            return schema
        },
    },
    mounted() {
        if (this.imagePosition === 'left-float') {
            // this.containerWidth = 320

            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container)
                    this.containerWidth = this.$refs.container.clientWidth
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                    if(this.containerWidth >= 721 || this.containerWidth == 320) {
                        this.containerWidth = 320
                    }else{
                        this.containerWidth = (this.containerWidth - 25)
                    }
                }
            }

            window.addEventListener('resize', debounce(calculateMaxWidth, 100))
            calculateMaxWidth()

        } else {
            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container)
                    this.containerWidth = this.$refs.container.clientWidth
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
                }
            }

            window.addEventListener('resize', debounce(calculateMaxWidth, 100))
            calculateMaxWidth()
        }
    }
}
</script>

<style lang="sass" >

    @import "~bulma/sass/utilities/mixins"

    .content .schema 
        a
            color: #aa00cc
            text-decoration: underline
        strong
            color: #666

    .schema.classic 
        .left-float
            float: left
            margin-right: 30px
        .clear
            clear: both

    

    .section.post
        +tablet
            .wrap
                display: flex
                .images.left-float
                    float: left
                    // width: 320px
                    display: block
                    // flex-shrink: 0
                    margin-right: 30px
                    padding-top: 6px
                .images.top-block
                    margin-bottom: 25px
                    display: flex
                    flex-direction: column
                    align-items: center

</style>
